export default "__VITE_ASSET__CMNtNxTR__"